export const TOGGLE_SNACK = "snackbar/TOGGLE_SNACK";
export const RESET_SNACK = "snackbar/RESET_SNACK";
